module.exports = __webpack_public_path__ + "static/media/57.baf6bf8d.jpg";